import Route from '@ember/routing/route';
import { service } from '@ember/service';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type SessionContextService from 'tio-employee/services/session-context';
import { fetchLinkingInfoRequest } from 'tio-common/requests/account';

export default class AuthenticatedSyfLinkingConfirmationRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;

  async model({ institution_id }: { institution_id: string }) {
    // By the time we get to this step the account is already linked.
    // This call can be used to get information about the last step.
    const response = await this.store.request(
      // Authenticated routes guarantee user.id is set at runtime; the
      // model field is typed string | null because UserModel can also
      // represent the empty session-context placeholder.
      fetchLinkingInfoRequest(this.sessionContext.user.id as string, institution_id, 2)
    );
    const linkedAccountData = response.content as { id: string };

    return await this.store.findRecord('account', linkedAccountData.id, {
      include: 'loans,financial-institution',
      reload: true,
    });
  }
}
